/** Temporary stub until onboarding API exposes the inviting organisation name. */
export const STUB_INVITING_COMPANY_NAME = "Maison Verdant SRL"

export const getStubInvitingCompanyName = (): string => STUB_INVITING_COMPANY_NAME
